/**
 * The maximum number of retries for a query.
 */
export const MAX_RETRY = 2;

/**
 * Calculates the delay time using exponential backoff strategy.
 * @param failureCount - The number of consecutive failures.
 * @param baseDelay - The initial delay in milliseconds (default is 3000 ms).
 * @param maxDelay - The maximum delay in milliseconds (default is 60000 ms).
 * @returns The calculated delay time in milliseconds.
 */
export function calculateExponentialBackoff(
	failureCount: number,
	baseDelay: number = 3000,
	maxDelay: number = 60000
): number {
	return Math.min(baseDelay * 3 ** failureCount, maxDelay);
}
